import { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Instructions.module.css';

/*
Instructions is the component that display instructions usually
html formatted of a Recipe/Pairing card
props:
instructionsHtml: instructions in text or Html format.
*/
const Instructions = ({
  instructionsHtml,
  open = false,
  hideToggle = false,
}) => {
  let [isOpen, toggle] = useState(open);
  let toggleOpen = () => {
    isOpen ? toggle(false) : toggle(true);
  };
  return (
    <div className="instructions">
      <div className={styles['hr-mobile']}>
        <div>
          <span className="hr-demi">Instructions</span>
          {hideToggle ? null : (
            <span
              className="hr-plr-8 toggle-container"
              onClick={() => toggleOpen()}
            >
              (<span className="toggle">{isOpen ? 'hide' : 'show'}</span>)
            </span>
          )}
        </div>
        {isOpen ? (
          <h2
            className="instructions-text"
            dangerouslySetInnerHTML={{ __html: instructionsHtml }}
          ></h2>
        ) : null}
      </div>
      <div className={styles['hr-desktop']}>
        <div className="hr-demi">Instructions</div>
        <h2
          className="instructions-text"
          dangerouslySetInnerHTML={{ __html: instructionsHtml }}
        ></h2>
      </div>
    </div>
  );
};

Instructions.propTypes = {
  instructionsHtml: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

export default Instructions;
